























































import { Component, Prop, Vue } from 'vue-property-decorator'
import PlayerCreateVue from '@/components/players/player.create.vue'
import { MeModel } from '@/components/api/api.clients'
import { userClient } from '@/components/api/clients.context'

@Component({
    components: {
        PlayerCreateVue
    }
})

export default class Me extends Vue {
  user :MeModel|null = null
  busy:boolean=false
  checked:boolean=false
  username:string|null=null
  duplicate:boolean=false

  async mounted () {
      await this.load()
  }

  async load () {
      this.busy = true
      this.user = await userClient.getMe()
      this.busy = false
  }

  async checkUserName () {
      if (this.username != null) {
          this.checked = await this.checkInternal(this.username)
      } else {
          this.checked = false
      }

      this.$forceUpdate()
  }

  async checkInternal (name:string):Promise<boolean> {
      if (this.username && this.username.length > 3) {
          const aviable :boolean = (await userClient.isUerNameFree(this.username))
          this.duplicate = !aviable
          return aviable
      } else {
          this.duplicate = false
          return false
      }
  }

  async Save () {
      if (!this.busy && this.username) {
          this.busy = true
          const name :string = this.username
          const check: boolean = await this.checkInternal(name)
          if (check) {
              await userClient.setUserName({ name: name })
              await this.load()
          }

          this.$forceUpdate()
          this.busy = false
      }
  }
}
